function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M0 0 C0 18.48 0 36.96 0 56 C-5.61 56.99 -11.22 57.98 -17 59 C-20.15586238 60.14781769 -22.65273065 61.1025475 -25.5 62.6875 C-26.15669678 63.03707764 -26.81339355 63.38665527 -27.48999023 63.74682617 C-37.38992414 69.20653753 -43.53600907 76.14199025 -49 86 C-49.60134766 87.04220703 -49.60134766 87.04220703 -50.21484375 88.10546875 C-54.1651513 95.81229517 -54.41828105 103.03692597 -56 112 C-74.48 112 -92.96 112 -112 112 C-112 79.87707344 -101.10221195 53.85026194 -79.1875 30.75 C-57.36393829 9.75256681 -30.06729277 0 0 0 Z ",
  fill: "#DF0819",
  transform: "translate(112,0)"
});

var SvgPtaCarretasLogo = function SvgPtaCarretasLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 112,
    height: 112,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPtaCarretasLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pta-carretas-logo.c60e4d4f.svg";
export { ForwardRef as ReactComponent };